import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
 Container
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { Box, Typography, Grid, Card, useTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import Navbar from "./Navbar";
import { KeyboardArrowDown } from "@mui/icons-material";
import Footer from "./Footer";
const AboutUs = () => {
  const theme = useTheme();
 const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqData = [
    {
      question: "How much does it cost to ship a car?",
      answer: "The cost of shipping a car depends on the distance, type of vehicle, and shipping method.",
    },
    {
      question: "Can I place items in my vehicle?",
      answer: "While some companies allow small personal items, it is generally not recommended due to liability concerns.",
    },
    {
      question: "How long does it take to ship a vehicle?",
      answer: "The duration varies based on the distance and route but typically ranges from a few days to two weeks.",
    },
    {
      question: "How far in advance should I book?",
      answer: "It is recommended to book at least 1-2 weeks in advance to ensure availability.",
    },
    {
      question: "Do you guarantee a pickup/delivery date?",
      answer: "Most companies provide estimated dates but cannot guarantee exact times due to unforeseen factors.",
    },
  ];

  return (
    <>
    <Box sx={{  backgroundColor: "#fff",width:'90%',marginLeft:'5%' }}>
      <Navbar/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <Typography
        variant="h4"
        align="center"
        sx={{marginBottom: "1rem" , fontFamily: "'Nunito', sans-serif",fontWeight:'600'}}
      >
        About Us
      </Typography>

       <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
              <KeyboardArrowDown fontSize="large" />
            </Box>
            <br/>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography
            variant="overline"
            sx={{ color: theme.palette.grey[700], fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}
          >
            Creative Approach
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", marginBottom: "1rem",fontFamily: "'Nunito', sans-serif" }}
          >
            Our Achievements: A Track Record of Success
          </Typography>
          <Typography variant="body1" sx={{ marginBottom: "2rem", color: theme.palette.grey[700] }}>
            More Than Just Numbers. A Commitment to Excellence.
          </Typography>
          <Box>
            {[
              "Hundreds of Satisfied Customers",
              "Successful Shipments",
              "Industry Recognition",
            ].map((text, index) => (
              <Box key={index} sx={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                <CheckIcon sx={{ color: theme.palette.primary.main, marginRight: "0.5rem" }} />
                <Typography variant="body1">{text}</Typography>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md={6} sx={{ position: "relative" }}>
          <img
            src="./service_img3.jpg"
            alt="Railway scene"
            style={{ width: "100%", borderRadius: "8px" }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "2rem",
              left: "1rem",
              display: "flex",
              gap: "1rem",
            }}
          >
            <Card
              sx={{
                backgroundColor: theme.palette.warning.main,
                color: "#fff",
                padding: "1rem 1.5rem",
                textAlign: "center",
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                800+
              </Typography>
              <Typography variant="body2">Cars Shipped</Typography>
            </Card>
            <Card
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: "#fff",
                padding: "1rem 1.5rem",
                textAlign: "center",
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                500+
              </Typography>
              <Typography variant="body2">Customers</Typography>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
    <Container maxWidth="md" sx={{ mt: 6, mb: 6 }}>
      <Card sx={{ p: 4, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", mb: 2 }}
        >
          Frequently Asked Questions
        </Typography>
        <Typography align="center" paragraph>
          Explore answers to common auto transport queries. If you need more info, reach out to our dedicated team at <strong>+1 (571) 267-1633</strong> for a comprehensive understanding of the entire process.
        </Typography>

        {faqData.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expanded === index}
            onChange={handleChange(index)}
            sx={{
              mb: 1,
              borderRadius: 2,
              backgroundColor: "white",
              boxShadow: expanded === index ? "0 4px 10px rgba(0, 0, 0, 0.1)" : "none",
              transition: "box-shadow 0.3s ease",
            }}
          >
            <AccordionSummary
              expandIcon={
                expanded === index ? (
                  <RemoveIcon sx={{ color: "#007BFF" }} />
                ) : (
                  <AddIcon sx={{ color: "#007BFF" }} />
                )
              }
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography sx={{ fontWeight: "600", fontSize: "1.1rem" }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ color: "#555" }}>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Card>
    </Container>
    <Footer/>
    </>
  );
};

export default AboutUs;
